import { RuntimeMistakeDetailScreen } from '@/features/unified-learning/runtime/screens/RuntimeMistakeDetailScreen';

export default function LearnMistakeDetailRoute() {
  return <RuntimeMistakeDetailScreen runtimeBase="/learn/path" />;
}
